module.exports = __webpack_public_path__ + "img/step1-1.7c6e0aab.png";